export const snotifyConfig = {
  timeout: 5000,
  titleMaxLength: 40,
  showProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
}
